import { Buffer } from 'buffer'
import { uniq } from 'lodash'
import AppStore from '../../../store/AppStore'
import ToastrAction from '../../../toastr/actions/ToastrAction'
import i18n from '../../../simple-react-i18n'

const readImportCsvStationsCodes = (e, refs, cb) => {
    const reader = new FileReader()
    const file = e.target.files[0]
    reader.onload = upload => {
        const split = upload.target.result.split(',')
        if (split[0].indexOf('text/csv') > 0 || split[0].indexOf('vnd.ms-excel') > 0) {
            const buf = Buffer.from(split[1], 'base64').toString()
            const codes = buf.split('\n').map(b => b.split(';')[0].trim()).map(b => b.split('\t')[0].trim())
            const filteredCodes = codes.filter((c) => c !== '')
            cb(filteredCodes)
        } else {
            AppStore.dispatch(ToastrAction.error(i18n.theSelectedFileMustBeInCsvFormat))
        }
        refs.importFile.value = ''
    }
    reader.readAsDataURL(file)
}

export { readImportCsvStationsCodes }